import React from "react";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";
import { Helmet } from "react-helmet";

const WhyChooseUs = () => {
  return (
    <div className="max-w-container mx-auto px-4">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Why Choose RK Global Trader for Export Business</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        />
        <meta
          name="description"
          content="Discover why RK Global Trader is the trusted partner for international exports. Learn about our expertise in agriculture exports, commitment to quality, reliable logistics, and global trade solutions."
        />
        <meta
          name="keywords"
          content="RK Global Trader, export business, international trade, agriculture exports, quality products, reliable partner, global commerce, export from India, organic produce, trading website, import website"
        />
        <meta
          name="author"
          content="RK Global Trader | Agriculture Products | Export from India"
        />
        <link
          rel="canonical"
          href="https://www.rkglobaltrader.com/whychooseus"
        />
      </Helmet>

      <Breadcrumbs title="Why Choose Us" />

      <div className="pb-10 space-y-6">
        <div className="pl-11 pr-11">
          <h1 className="text-base text-lightText text-justify mb-2 mt-2">
            RK Global Trader is committed to delivering only the highest-quality
            agriculture products to international markets. Our fresh fruits,
            vegetables, and other commodities are certified organic, grown
            under international standards, and packaged sustainably for global
            trade. Choosing RK Global Trader ensures reliability, quality, and
            professionalism in every transaction.
          </h1>
        </div>

        <div className="pl-11 pr-11">
          <h2 className="text-primeColor font-semibold text-lg mb-2">
            Extensive Export Experience
          </h2>
          <p className="text-base text-lightText text-justify">
            With years of experience in exporting to diverse international
            markets, RK Global Trader navigates regulatory requirements and
            industry challenges efficiently, ensuring smooth trade operations.
          </p>
        </div>

        <div className="pl-11 pr-11">
          <h2 className="text-primeColor font-semibold text-lg mb-2">
            Comprehensive Export Solutions
          </h2>
          <p className="text-base text-lightText text-justify">
            We offer end-to-end services including logistics, documentation,
            customs clearance, and export compliance, providing a seamless
            experience for our partners and clients.
          </p>
        </div>

        <div className="pl-11 pr-11">
          <h2 className="text-primeColor font-semibold text-lg mb-2">
            Global Network and Partnerships
          </h2>
          <p className="text-base text-lightText text-justify">
            RK Global Trader maintains strong relationships with trusted partners
            worldwide, ensuring timely delivery, reliability, and expanded
            market reach for our export clients.
          </p>
        </div>

        <div className="pl-11 pr-11">
          <h2 className="text-primeColor font-semibold text-lg mb-2">
            Innovative Trade Practices
          </h2>
          <p className="text-base text-lightText text-justify">
            Leveraging advanced technologies and innovative solutions, we
            optimize the export process for efficiency, transparency, and
            sustainability.
          </p>
        </div>

        <div className="pl-11 pr-11">
          <h2 className="text-primeColor font-semibold text-lg mb-2">
            Dedicated Customer Support
          </h2>
          <p className="text-base text-lightText text-justify">
            We prioritize clear communication and responsive support, ensuring
            that every client inquiry is addressed promptly and professionally.
          </p>
        </div>

        <div className="pl-11 pr-11">
          <h2 className="text-primeColor font-semibold text-lg mb-2">
            Get in Touch
          </h2>
          <p className="text-base text-lightText text-justify">
            Partner with RK Global Trader to experience unmatched expertise,
            reliability, and excellence in international trade. Contact us today
            to explore new export opportunities and elevate your global business.
          </p>
          <p className="text-base text-lightText text-justify mt-2">
            Thank you for choosing RK Global Trader — Where Global Opportunities
            Await!
          </p>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
